import axios from 'axios'
import { onSuccess, onError, signbeforeRequestSuccess, beforeRequestError } from '../interceptors' // noAuthBeforeRequestSuccess
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const userClient = axios.create({
  baseURL: process.env.CALLING_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

userClient.interceptors.request.use(signbeforeRequestSuccess, beforeRequestError)
userClient.interceptors.response.use(onSuccess, onError)

export let client = userClient



// WEBPACK FOOTER //
// ./src/api/calling/client.js